module.exports = __webpack_public_path__ + "img/American-Samoa.40555b14.png";